import { Row, Col } from 'react-bootstrap';

export default function Mapa() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em <a href="/institucional">Institucional</a> / Mapa do Site</small></p>
                <h1>Mapa do Site</h1>

                <ul>
                    <li>
                        <a href="/institucional">Institucional</a>
                        <ul>
                            <li><a href="/institucional/atribuicoes">Atribuições da Alepe</a></li>
                            <li><a href="https://www.alepe.pe.gov.br/estrutura/">Estrutura Legislativa</a></li>
                            <li><a href="https://www.alepe.pe.gov.br/estrutura-administrativa/">Estrutura Administrativa</a></li>
                            <li><a href="https://www.alepe.pe.gov.br/deputados/">Deputados</a></li>
                            <li><a href="/institucional/atendimento-ao-publico/">Atendimento ao Público</a></li>
                            <li><a href="/institucional/servicos/">Nossos Serviços</a></li>
                            <li><a href="https://dadosabertos.alepe.pe.gov.br">Portal de Dados Abertos</a></li>
                            <li><a href="/institucional/informacoes-classificadas">Informações Classificadas em Grau de Sigilo</a></li>
                            <li><a href="/institucional/informacoes-desclassificadas">Informações Desclassificadas em Grau de Sigilo</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="/ouvidoria">SIC e Ouvidoria</a>
                        <ul>
                            <li><a href="/ouvidoria/nova-solicitacao">Nova Solicitação</a></li>
                            <li><a href="/ouvidoria/acompanhamento">Acompanhamento</a></li>
                            <li><a href="/ouvidoria/relatorios">Ouvidoria</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="/legislacao">Legislação</a>
                        <ul>
                            <li><a href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm">L.A.I. Federal</a></li>
                            <li><a href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2012/decreto/d7724.htm">Decreto Federal</a></li>
                            <li><a href="https://legis.alepe.pe.gov.br/texto.aspx?id=1605&tipo=">L.A.I. Poder Executivo Estadual</a></li>
                            <li><a href="/legislacao/decreto-executivo-estadual">Decreto Poder Executivo Estadual</a></li>
                            <li><a href="https://legis.alepe.pe.gov.br/texto.aspx?id=4481&tipo=">L.A.I. Alepe</a></li>
                            <li><a href="https://legis.alepe.pe.gov.br">Alepe Legis</a></li>
                            <li><a href="https://legis.alepe.pe.gov.br/texto.aspx?id=10401&tipo=">Código de Ética Parlamentar</a></li>
                            <li><a href="https://legis.alepe.pe.gov.br/texto.aspx?id=10727&tipo=">Estatuto dos Servidores Públicos</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="/pessoal">Gestão de Pessoas</a>
                        <ul>
                            <li><a href="/pessoal/listagem-servidores">Listagem de Pessoal</a></li>
                            <li><a href="https://legis.alepe.pe.gov.br/texto.aspx?id=32&tipo=">Planos de Cargos</a></li>
                            <li><a href="/pessoal/servidores-efetivos">Servidores Efetivos</a></li>
                            <li><a href="/pessoal/servidores-comissionados">Servidores Comissionados</a></li>
                            <li><a href="/pessoal/por-lotacao">Por Lotação</a></li>
                            <li><a href="/pessoal/servidores-cedidos">Servidores Cedidos</a></li>
                            <li><a href="/pessoal/servidores-a-disposicao">Servidores à Disposição</a></li>
                            <li><a href="/pessoal/tabelas-remuneracao">Tabelas de Remuneração</a></li>
                            <li><a href="https://www.alepe.pe.gov.br/atos-portarias">Atos e Portarias</a></li>
                            <li><a href="/pessoal/concurso-publico">Concurso Público</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="/financas">Prestação de Contas</a>
                        <ul>
                            <li><a href="/financas/gestao-fiscal">Gestão Fiscal</a></li>
                            <li><a href="/financas/receitas">Receitas</a></li>
                            <li><a href="/financas/despesas">Despesas</a></li>
                            <li><a href="/financas/relatorios-atividades">Relatórios de Atividades</a></li>
                            <li><a href="/financas/prestacao-contas-anual">Prestação de Contas Anual</a></li>
                            <li><a href="/financas/orcamento">Orçamento</a></li>
                            <li><a href="/financas/licitacoes">Licitações</a></li>
                            <li><a href="/financas/dispensas-de-licitacao">Dispensas de Licitação</a></li>
                            <li><a href="/financas/contratos">Contratos</a></li>
                            <li><a href="/financas/gestores-e-fiscais">Gestores e Fiscais de Contratos</a></li>
                            <li><a href="/financas/transferencias-voluntarias">Transferências Voluntárias</a></li>
                            <li><a href="/financas/verbas-indenizatorias">Verbas Indenizatórias</a></li>
                            <li><a href="/financas/remuneracao-deputados">Remuneração e Ajuda de Custo dos Deputados</a></li>
                            <li><a href="/financas/atas-registro-preco">Atas de Registro de Preço</a></li>
                            <li><a href="/financas/licitantes-sancionados">Licitantes ou Contratados Sancionados Administrativamente</a></li>
                            <li><a href="/financas/obras">Obras</a></li>
                            <li><a href="/financas/obras-paralisadas">Obras Paralisadas</a></li>
                            <li><a href="/financas/apreciacao-contas">Apreciação de Contas do Executivo Estadual</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="/lgpd">Proteção de Dados Pessoais (LGPD)</a>
                        <ul>
                            <li><a href="/lgpd">LGPD na Alepe</a></li>
                        </ul>
                    </li>
                </ul>
            </Col>
        </Row>
    );
}
